// „Jasmin Bescheid geben“ (Gasbestellung): aus der ausgefüllten Bestellung wird automatisch eine Meldung an den
// Einkauf (einkauf_aufgaben) — Jasmin sieht sie wie jede neue Bestellung: Konfetti-Popup, rotes Badge, NEU-Etikett.
import type { GasPosition } from './api';

const hatMenge = (m?: string) => !!m && m.trim() !== '' && m.trim() !== '0';
export const GAS_TITEL_PRAEFIX = 'Gasbestellung';

export interface GasBescheidBilanz { erfasst: boolean; bestand: number; bestellt: number; leergut: number; nach: number; max: number }
export interface GasBescheidKopf { wunschtermin?: string; lieferadresse?: string; bestelltext?: string }

const datumDE = (iso?: string) => {
  const m = iso?.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : (iso ?? '');
};

export function gasBescheid(positionen: GasPosition[], kopf: GasBescheidKopf, leergutText: string, bil: GasBescheidBilanz | null): { titel: string; notiz: string } {
  const pos = positionen.filter(p => hatMenge(p.menge));
  const kurz = pos.slice(0, 4).map(p => `${p.menge}× ${p.artikel || p.artnr}`).join(', ');
  const rest = pos.length > 4 ? ` … +${pos.length - 4} weitere` : '';
  const titel = `${GAS_TITEL_PRAEFIX}: ${kurz}${rest}`;
  const zeilen = [
    ...pos.map(p => `• ${p.menge} × ${p.artikel}${p.artnr ? ` (Art.-Nr. ${p.artnr}${p.groesse ? `, ${p.groesse}` : ''})` : ''}`),
    kopf.wunschtermin ? `Wunschtermin: ${datumDE(kopf.wunschtermin)}` : '',
    kopf.lieferadresse ? `Lieferadresse: ${kopf.lieferadresse.replace(/\n/g, ', ')}` : '',
    kopf.bestelltext ? `Bestelltext/-Nr.: ${kopf.bestelltext}` : '',
    leergutText ? `Leergut zurück: ${leergutText}` : '',
    bil?.erfasst ? `Flaschen: Bestand ${bil.bestand} + bestellt ${bil.bestellt} − Leergut ${bil.leergut} = ${bil.nach} / max. ${bil.max}${bil.nach > bil.max ? ' ⛔ ZU VIEL' : ''}`
                 : 'Flaschenbestand noch nicht eingetragen.',
    'Die Bestellung ist unter „Gasbestellung" gespeichert — dort PDF/Outlook-Entwurf erzeugen.',
  ].filter(Boolean);
  return { titel, notiz: zeilen.join('\n') };
}
